const _ = "544px", E = "768px", I = "992px", O = "1280px", P = "1440px";
export {
  I as W_BREAKPOINT_VIEWPORT_L,
  E as W_BREAKPOINT_VIEWPORT_M,
  _ as W_BREAKPOINT_VIEWPORT_S,
  O as W_BREAKPOINT_VIEWPORT_XL,
  P as W_BREAKPOINT_VIEWPORT_XXL
};
